import { createUseStyles } from 'react-jss';
export default createUseStyles((theme) => ({
    container: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        maxWidth: 330,
        alignItems: 'center',
        justifyContent: 'center',
    },
    input: {
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        padding: '0 16px',
        height: 48,
        width: '100%',
        borderRadius: 5,
        border: `1px solid ${theme.palette.grey[15]}`,
        cursor: 'pointer',
        marginTop: 10
    },
    icon: {
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
        width: 'auto',
        marginBottom: '8px',
    },
    menu: { border: `1px solid ${theme.palette.grey[15]}` },
    label: { width: '100%' },
    placeholder: { color: theme.palette.grey[8] },
    options: {
        display: 'flex',
        flexDirection: 'column',
        position: 'absolute',
        backgroundColor: 'white',
        top: '100%',
        left: 0,
        width: '100%',
        borderRadius: 5,
        border: '1px solid #c1c1c1',
        zIndex: 1001,
        maxHeight: 170,
        overflowY: 'auto',
        overflowX: 'hidden',
        boxShadow: '0px 10px 10px #0000002'
    },
}));
//# sourceMappingURL=styles.js.map